"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.howAppIsRunning = exports.findOutEnv = exports.findOutEnvByHost = exports.ENV_URLS = exports.MAIN_ENV = exports.TELCO_ENVS = exports.PROCESS_NAME = exports.FAMILY_API = exports.ENV_NAME = void 0;
exports.ENV_NAME = {
    PROD: 'prod',
    INTE: 'inte',
    QA: 'qa',
    DEV: 'dev',
};
exports.FAMILY_API = {
    NAME: 'name',
    HOST: 'host',
    CUSTO: 'custo',
    CUSTOCDN: 'custoCdn',
    GEO: "geo",
    CATALOGUE: 'catalogue',
    TELCO: 'telco',
    LEGADO: 'legado',
    LEGADONOVCM: 'legadoNoVCM',
    BUCKET: 'bucket',
    ORION: 'orion',
    TGES: 'tges',
    TELCOFRONT: 'telcoFront',
    SECURITY: 'security',
    TECALIS: 'tecalis',
};
// TODO: Analizar si PROCESS_NAME.OPEN es necesario. 
exports.PROCESS_NAME = {
    CLIENT: 'ADABYRON-API',
    OPEN: 'ADABYRON-API-OPEN'
};
const ORION_ENVS = {
    DEV: {
        endpoint: 'https://qa.orion.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    QA: {
        endpoint: 'https://qa.orion.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://orion.col.movistar.es',
        headers: {},
    },
};
const BUCKET_ENVS = {
    DEV: {
        endpoint: 'https://prod.cms.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    QA: {
        endpoint: 'https://qa.cms.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://prod.cms.col.movistar.es',
        headers: {},
    },
};
exports.TELCO_ENVS = {
    DEV: {
        endpoint: 'http://tehrhadx.serv.dev.dc.es.telefonica:11010',
        headers: {},
    },
    INTE: {
        endpoint: 'https://www.movistar.es.inte',
        headers: {},
    },
    QA: {
        endpoint: 'http://tehrhad5.serv.test.dc.es.telefonica:11010',
        headers: {},
    },
    CERT: {
        endpoint: 'https://www.movistar.es.cert',
        headers: {},
    },
    FARM1: {
        endpoint: 'https://tcolgranja1.es.telefonica',
        headers: {},
    },
    FARM2: {
        endpoint: 'https://tcolgranja2.es.telefonica',
        headers: {},
    },
    PROD: {
        endpoint: 'https://www.movistar.es',
        headers: {},
    },
};
const TGES_ENVS = {
    DEV: {
        endpoint: 'https://api.dev.es.telefonica/api/rest/intranet/TGES',
        headers: {
            withCredentials: true,
        },
    },
    QA: {
        endpoint: 'https://api.test.es.telefonica/api/rest/intranet/TGES',
        headers: {
            withCredentials: true,
        },
    },
    FARM1: {
        endpoint: 'https://api.telefonica.es/api/rest/TGESTest',
        headers: {
            withCredentials: true,
        },
    },
    FARM2: {
        endpoint: 'https://api.telefonica.es/api/rest/TGESTest',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://api.telefonica.es/api/rest/TGES',
        headers: {
            withCredentials: true,
        },
    },
};
const INFO_CONTEXTO = {
    DEV: {
        endpoint: 'https://www.movistar.es.cert',
        headers: {},
    },
    QA: {
        endpoint: 'https://www.movistar.es.cert',
        headers: {},
    },
    PROD: {
        endpoint: 'https://www.movistar.es',
        headers: {},
    },
};
const LEGADO_ENVS = {
    DEV: {
        endpoint: 'https://col10mgmt.tsm.inet',
        headers: {},
    },
    QA: {
        endpoint: 'https://www.movistar.es.cert',
        headers: {},
    },
    PROD: {
        endpoint: 'https://www.movistar.es',
        headers: {},
    },
};
const CUSTOMIZER_ENVS = {
    DEV: {
        endpoint: 'https://customizer-dot-mov-dev15.appspot.com',
        headers: {},
    },
    QA: {
        endpoint: 'https://qa.customizer.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://customizer.col.movistar.es',
        headers: {
            timeout: 10000,
            withCredentials: true,
        },
    },
};
const CUSTOMIZER_CDN_ENV = {
    DEV: {
        endpoint: 'https://customizer.dev.col.movistar.es',
        headers: {},
    },
    QA: {
        endpoint: 'https://qa.customizer.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://customizer.col.movistar.es',
        headers: {
            timeout: 10000,
        },
    },
};
const CATALOGUE_ENVS = {
    DEV: {
        endpoint: 'https://qa.catalogue.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    QA: {
        endpoint: 'https://qa.catalogue.col.movistar.es',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://catalogue.col.movistar.es',
        headers: {
            withCredentials: true,
            'content-type': 'application/json',
        },
    },
};
const SECURITY_ENVS = {
    DEV: {
        endpoint: 'https://apiseg-intranet.dev.es.telefonica',
        headers: {
            withCredentials: true,
        },
    },
    QA: {
        endpoint: 'https://apiseg-intranet.test.es.telefonica',
        headers: {
            withCredentials: true,
        },
    },
    PROD: {
        endpoint: 'https://apiseg-org.telefonica.es',
        headers: {
            withCredentials: true,
        },
    },
};
const TELCO_FRONT_ENVS = {
    DEV: {
        endpoint: 'https://t3-org-ein.dev.es.telefonica',
        headers: {},
    },
    QA: {
        endpoint: 'https://t3-org-ece.test.es.telefonica',
        headers: {},
    },
    PROD: {
        endpoint: 'https://t3.telefonica.es',
        headers: {},
    },
};
const TECALIS_ENVS = {
    DEV: {
        endpoint: 'https://int.ms-movistar.c2c.tecalis.dev/col/',
        headers: {},
    },
    QA: {
        endpoint: 'https://int.ms-movistar.c2c.tecalis.dev/col/',
        headers: {},
    },
    PROD: {
        endpoint: 'https://ms-movistar.c2c.tecalis.com/col/',
        headers: {},
    },
};
const GEO_ENVS = {
    DEV: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {},
    },
    QA: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {},
    },
    PROD: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
};
exports.MAIN_ENV = {
    [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
    [exports.FAMILY_API.HOST]: 'movistar.es',
    [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.PROD,
    [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
    [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.PROD,
    [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
    [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.PROD,
    [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.PROD,
    [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.PROD,
    [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.PROD,
    [exports.FAMILY_API.ORION]: ORION_ENVS.PROD,
    [exports.FAMILY_API.TGES]: TGES_ENVS.PROD,
    [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
    [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
    [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
};
exports.ENV_URLS = [
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: 'col10mgmt.tsm.inet',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.QA,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.QA,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.QA,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.DEV,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.QA,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.QA,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.QA,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.QA,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.INTE,
        [exports.FAMILY_API.HOST]: 'www.movistar.es.inte',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.QA,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.INTE,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.QA,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.DEV,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.DEV,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.DEV,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.QA,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: 'www.movistar.es.cert',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.QA,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.CERT,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.QA,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.QA,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.QA,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.QA,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.QA,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: 'qa.cms.col.movistar.es',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.QA,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.CERT,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.QA,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.QA,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.QA,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.QA,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.QA,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: 'tcolgranja1.es.telefonica',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.QA,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.FARM1,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.QA,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.FARM1,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: 'tcolgranja2.es.telefonica',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.QA,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.FARM2,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.QA,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.QA,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.FARM2,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.DEV,
        [exports.FAMILY_API.HOST]: '127.0.0.1',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.QA,
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.QA,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.QA,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.QA,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.DEV,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.QA,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.PROD,
        [exports.FAMILY_API.ORION]: ORION_ENVS.QA,
        [exports.FAMILY_API.TGES]: TGES_ENVS.QA,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.QA,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.QA,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.QA,
    },
    exports.MAIN_ENV,
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.HOST]: 'prod.cms.col.movistar.es',
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.PROD,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.PROD,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.PROD,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.PROD,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.PROD,
        [exports.FAMILY_API.ORION]: ORION_ENVS.PROD,
        [exports.FAMILY_API.TGES]: TGES_ENVS.PROD,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.HOST]: 'atencionalcliente.movistar.es',
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.PROD,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.PROD,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.PROD,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.PROD,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.PROD,
        [exports.FAMILY_API.ORION]: ORION_ENVS.PROD,
        [exports.FAMILY_API.TGES]: TGES_ENVS.PROD,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.HOST]: 'web.movistar.es',
        [exports.FAMILY_API.GEO]: GEO_ENVS.PROD,
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_ENVS.PROD,
        [exports.FAMILY_API.CUSTOCDN]: CUSTOMIZER_CDN_ENV.PROD,
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS.PROD,
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.PROD,
        [exports.FAMILY_API.LEGADO]: LEGADO_ENVS.PROD,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO.PROD,
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS.PROD,
        [exports.FAMILY_API.ORION]: ORION_ENVS.PROD,
        [exports.FAMILY_API.TGES]: TGES_ENVS.PROD,
        [exports.FAMILY_API.TELCOFRONT]: TELCO_FRONT_ENVS.PROD,
        [exports.FAMILY_API.SECURITY]: SECURITY_ENVS.PROD,
        [exports.FAMILY_API.TECALIS]: TECALIS_ENVS.PROD,
    },
];
const DEFAULT_LOCATION_BY_ENV_NAME = {
    [exports.ENV_NAME.DEV]: '127.0.0.1',
    [exports.ENV_NAME.QA]: 'qa.cms.col.movistar.es',
    [exports.ENV_NAME.PROD]: 'movistar.es',
};
const findOutEnvByHost = (envName) => {
    let selectedHost = DEFAULT_LOCATION_BY_ENV_NAME[envName];
    if (!selectedHost) {
        console.warn('envName no tipado');
        selectedHost = 'movistar.es';
    }
    return exports.ENV_URLS.find((item) => item.host === selectedHost) || exports.MAIN_ENV;
};
exports.findOutEnvByHost = findOutEnvByHost;
const findOutEnv = (defaultHost = 'movistar.es') => {
    let res = exports.ENV_URLS.find((item) => item.host === defaultHost) || exports.MAIN_ENV;
    try {
        const myUrl = document.location.href;
        const item = exports.ENV_URLS.find((envUrl) => {
            const { host } = envUrl;
            return myUrl.indexOf(host) !== -1;
        });
        if (item) {
            res = item;
        }
    }
    catch (err) {
        return res;
    }
    return res;
};
exports.findOutEnv = findOutEnv;
const howAppIsRunning = () => {
    const { NODE_ENV } = process.env;
    return NODE_ENV || '';
};
exports.howAppIsRunning = howAppIsRunning;
//# sourceMappingURL=index.js.map